import React, { useState, useEffect } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { Trash2, RefreshCw, AlertCircle, Calendar } from 'lucide-react';
import { restorePayment } from '../../services/kurbanService';

export default function TrashManagement() {
  const [deletedPayments, setDeletedPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [restoringId, setRestoringId] = useState(null);

  useEffect(() => {
    const q = query(collection(db, 'deleted_payments'));
    const unSub = onSnapshot(q, (snapshot) => {
      let data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // Bellekte tarihe göre sıralayalım (yeniden eskiye)
      data.sort((a,b) => {
         const t1 = a.deletedAt?.toMillis() || 0;
         const t2 = b.deletedAt?.toMillis() || 0;
         return t2 - t1;
      });
      setDeletedPayments(data);
      setLoading(false);
    });
    return () => unSub();
  }, []);

  const handleRestore = async (payment) => {
    if (!window.confirm(`${payment.receiptNo} numaralı makbuzu GERİ GETİRMEK istediğinize emin misiniz? Bu işlem hissedarın bakiyesini de otomatik onarır.`)) return;
    
    setRestoringId(payment.id);
    try {
      await restorePayment(payment.id);
      alert("Makbuz başarıyla orijinal yerine geri yüklendi!");
    } catch (err) {
      alert("Hata: " + err.message);
    } finally {
      setRestoringId(null);
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-3 bg-red-500/20 text-red-500 rounded-xl">
          <Trash2 className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white">Çöp Kutusu (Silinen Makbuzlar)</h1>
          <p className="text-sm text-navy-300">Sadece Süper Adminler tarafından görülebilen sistem çöp kutusu. Silinen makbuzlar burada arşivlenir.</p>
        </div>
      </div>

      <div className="bg-navy-900 border border-navy-700/50 rounded-2xl overflow-hidden shadow-xl">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-navy-300">
            <thead className="bg-navy-800/50 text-xs uppercase text-navy-400 font-semibold">
              <tr>
                <th className="px-6 py-4">Makbuz / Tarih</th>
                <th className="px-6 py-4">Tutar / Tür</th>
                <th className="px-6 py-4">Silen Kişi</th>
                <th className="px-6 py-4">İşlem</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-navy-800">
              {loading ? (
                <tr>
                  <td colSpan="4" className="px-6 py-10 text-center text-navy-400">
                    <RefreshCw className="w-6 h-6 animate-spin mx-auto mb-2 opacity-50" />
                    Yükleniyor...
                  </td>
                </tr>
              ) : deletedPayments.length === 0 ? (
                <tr>
                  <td colSpan="4" className="px-6 py-12 text-center text-navy-400">
                    <AlertCircle className="w-8 h-8 opacity-20 mx-auto mb-3" />
                    <p>Çöp kutusunda hiç silinmiş makbuz bulunmuyor.</p>
                  </td>
                </tr>
              ) : (
                deletedPayments.map((payment) => (
                  <tr key={payment.id} className="hover:bg-navy-800/30 transition-colors">
                    <td className="px-6 py-4">
                       <div className="text-white font-bold">{payment.receiptNo}</div>
                       <div className="text-xs text-navy-400 mt-0.5 flex items-center gap-1">
                          <Calendar className="w-3 h-3" />
                          Silinme: {payment.deletedAt?.toDate ? payment.deletedAt.toDate().toLocaleString('tr-TR') : 'Bilinmiyor'}
                       </div>
                    </td>
                    <td className="px-6 py-4">
                       <div className="text-white font-bold">{Number(payment.amount).toLocaleString('tr-TR')} ₺</div>
                       <div className="text-xs bg-navy-800 px-2 py-0.5 rounded-full inline-block mt-1">{payment.type}</div>
                    </td>
                    <td className="px-6 py-4">
                       <div className="text-red-400 font-medium">{payment.deletedBy || 'Bilinmiyor'}</div>
                    </td>
                    <td className="px-6 py-4">
                       <button
                         onClick={() => handleRestore(payment)}
                         disabled={restoringId === payment.id}
                         className="flex items-center gap-2 px-3 py-1.5 bg-forest-600/20 text-forest-400 border border-forest-500/30 hover:bg-forest-500 hover:text-white transition-all rounded-lg text-xs font-bold disabled:opacity-50"
                       >
                         {restoringId === payment.id ? <RefreshCw className="w-3 h-3 animate-spin"/> : <RefreshCw className="w-3 h-3" />}
                         GERİ GETİR
                       </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
